import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import css from "../commonMagneticStyle.less";
import { useI18n } from "../../i18n/useI18n";
import ErrorComponent from "../ErrorComponent";

function Unauthorized() {
  const { tCommon } = useI18n('common');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.isInValid) {
      return;
    }

    navigate(
      {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash
      },
      {
        replace: true,
        state: {
          ...location.state,
          isInValid: true
        }
      }
    );
  }, [location.hash, location.pathname, location.search, location.state, navigate]);
  return (
    <ErrorComponent code={"403"} message={tCommon('UnauthorizedMessage')} className={css["error_page_content"]}/>
  );
}

export default Unauthorized;
